import { NgModule } from '@angular/core';
import { Route } from '@angular/router';

@NgModule({
    imports: [],
    exports: [],
    providers: [],
})
export class ErrorPagesProxyModule {
    static defineRoute(path: string): Route {
        return {
            path,
            loadChildren: () =>
                import('app/shared/routing-proxies/error-pages.lazy.module').then(
                    (m) => m.ErrorPagesLazyLoadedModule,
                ),
        };
    }
}
